import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import logo from '../assets/ohlins-logo.png';
import icon from '../assets/ohlins-icon.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSignOutAlt,
  faHome,
  faPlane,
  faHotel,
  faCar,
  faUsers,
  faUser,
  faUserShield,
} from '@fortawesome/free-solid-svg-icons'

function Sidebar() {
  const navigate = useNavigate();
  const { isAdmin, logout } = useContext(AuthContext);
  const [adminStatus, setAdminStatus] = useState(isAdmin);

  useEffect(() => {
    setAdminStatus(isAdmin); // Update admin status when isAdmin changes
  }, [isAdmin]);

  const menu = [
    { name: "Home", path: "home", icon: faHome },
    { name: "Flights", path: "flights", icon: faPlane },
    { name: "Hotels", path: "hotels", icon: faHotel },
    { name: "Car Rental", path: "car-rental", icon: faCar },
    { name: "Team", path: "team", icon: faUsers },
    { name: "Profile", path: "profile", icon: faUser },
    ...(adminStatus ? [{ name: "Admin", path: "admin", icon: faUserShield }] : []),
  ];

  const handleLogout = () => {
    if (logout) {
      logout();
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("isAdmin");
    }
    navigate("/"); // Tillbaka till login
  };

  return (
  <aside className="w-72 sticky top-0 h-screen bg-gradient-to-b from-black via-gray-950 to-black text-white shadow-2xl flex flex-col justify-between border-r-4 border-yellow-400">
      {/* Header with new Ohlins branding */}
      <div className="px-6 py-8">
        <div className="flex items-center justify-center mb-6">
          <img src={icon} alt="Ohlins Icon" className="w-16 h-16 object-contain drop-shadow-lg" />
        </div>
        <div className="text-center mb-2">
          <img src={logo} alt="Ohlins Logo" className="mx-auto w-48 object-contain drop-shadow-lg" />
        </div>
        <div className="h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent mt-4"></div>
      </div>

      {/* Navigation menu */}
      <ul className="flex-1 px-4 py-6 space-y-3 overflow-y-auto">
        {menu.map((item) => (
          <li key={item.name}>
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-4 px-5 py-3 rounded-lg transition duration-200 font-semibold text-lg ${
                  isActive 
                    ? "bg-yellow-400 text-black shadow-lg shadow-yellow-400/50 scale-105" 
                    : "hover:bg-gray-900 text-gray-300 hover:text-yellow-300 hover:scale-102"
                }`
              }
              end
            >
              {item.icon && (
                <FontAwesomeIcon
                  icon={item.icon}
                  className="w-5 h-5"
                />
              )}
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>

      {/* Divider */}
      <div className="mx-4 h-px bg-gradient-to-r from-transparent via-yellow-400 to-transparent"></div>

      {/* Logout button */}
      <ul className="px-4 py-4 space-y-3">
        <li>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-4 px-5 py-3 rounded-lg hover:bg-red-900 transition duration-200 font-semibold text-lg text-gray-300 hover:text-white hover:shadow-lg hover:shadow-red-900/50"
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="w-5 h-5" />
            <span>Logout</span>
          </button>
        </li>
      </ul>

      {/* Footer info */}
      <div className="px-6 pb-6 text-center border-t border-gray-800 pt-4">
        <p className="text-xs text-gray-500 tracking-wider">MOTORSPORT TEAM</p>
        <p className="text-xs text-gray-600 mt-2">© Ohlins Racing</p>
      </div>
    </aside>
  );
}

export default Sidebar;
